import { render, staticRenderFns } from "./ShipmentManager.vue?vue&type=template&id=4f11350b"
import script from "./ShipmentManager.vue?vue&type=script&lang=js"
export * from "./ShipmentManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports